import { TableColumn } from './TableColumn.js';
export class TableDatasource extends EventTarget {
  constructor(options) {
    super();
    this.page = 1;
    this.pages = 1;
    this.limit = 10;
    this.sort = null;
    this.search = null;
    this.filters = {};
    this.aggregates = null;
    this.populate = null;
    this.total = 0;
    this.active = true;
    this.showFilterRow = false;
    this.disableHandler = null;
    this.selectionHandler = null;
    this.load = null;
    this.docs = [];
    this.storeState = {};
    this.pristine = true;
    this.setInitialState(options);
  }
  setInitialState(options = {}) {
    const columns = options.columns || options._columns || [];
    const initialState = {
      ...options
    };
    delete initialState._columns;
    delete initialState.columns;
    const storeState = options.storeState || {};
    if (storeState && storeState.enabled) {
      if (storeState.delete) {
        localStorage.removeItem(storeState.delete);
      }
      const state = JSON.parse(localStorage.getItem(storeState.key));
      if (state) {
        this.limit = state.limit;
        if (state.columns) {
          state.columns.forEach(stateCol => {
            const column = columns.find(col => col.source === stateCol.source);
            if (column) {
              Object.assign(column, stateCol);
            }
          });
        }
      }
    }
    Object.assign(this, initialState);
    this.columns = columns;
  }
  set columns(columns) {
    if (columns && columns instanceof Array && columns.length) {
      this._columns = columns.map(col => col instanceof TableColumn ? col : new TableColumn(col));
    } else {
      this._columns = this.docs && this.docs.length ? Object.keys(this.docs[0]).map(key => new TableColumn({
        source: key
      })) : [];
    }
    this._onUpdate();
  }
  get columns() {
    return this._columns;
  }
  refresh() {
    this._onUpdate();
  }
  _onUpdate() {
    this.saveState();
    this._emitUpdateEvent();
  }
  _emitUpdateEvent() {
    this.dispatchEvent(new CustomEvent('update', {
      detail: this
    }));
  }
  async refreshData(loadOptions = {}) {
    if (this.load && typeof this.load === 'function') {
      const {
        page = this.page,
        limit = this.limit,
        sort = this.sort,
        search = this.search,
        filters = this.filters,
        aggregates = this.aggregates,
        populate = this.populate
      } = loadOptions;
      const fetchOptions = {
        page,
        limit,
        sort,
        search,
        filters,
        aggregates,
        populate
      };
      const response = await this.load(fetchOptions);
      this.pristine = false;
      if (response) {
        Object.assign(this, fetchOptions, response);
        if (!this.columns || !this.columns.length) {
          this.columns = null;
        }
      } else {
        Object.assign(this, fetchOptions, {
          page: 1,
          pages: 1,
          total: 0,
          docs: []
        });
      }
      this._onUpdate();
    }
  }
  saveState() {
    if (this.storeState && this.storeState.enabled) {
      const state = {
        columns: this.columns.filter(col => col.showInColumnChooser && col.source).map(col => ({
          source: col.source,
          visible: col.visible
        })),
        limit: this.limit
      };
      localStorage.setItem(this.storeState.key, JSON.stringify(state));
    }
  }
}